
<div class="video-player-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="loading">
    <div class="spinner"></div>
    <p>Carregando vídeo...</p>
  </div>

  <!-- Error -->
  <div *ngIf="!isLoading && errorMessage" class="error">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    <p>{{ errorMessage }}</p>
    <button (click)="retry()" class="retry-btn">Tentar Novamente</button>
  </div>
  <div class="quality-selector" >
    <label>Qualidade:</label>
    <select [(ngModel)]="selectedLevel" (change)="changeQuality(selectedLevel)">
      <option [value]="-1">Automática</option>
      <option *ngFor="let lvl of availableLevels" [value]="lvl.index">
        {{ lvl.height }}p
      </option>
    </select>
  </div>
  <!-- Video Player -->
 <div *ngIf="!isLoading && !errorMessage && isVideoReady" class="video-wrapper">
  <video 
    #videoElement
    controls
    class="video-element"
    playsinline>
    Seu navegador não suporta reprodução de vídeo.
  </video>

  <!-- Seletor de qualidade fora do <video> -->

</div>
